import { makeOffesetPaginationState, STATUSES } from 'app/utils/redux';

import * as t from './types';


const initialState = {
  notifications: makeOffesetPaginationState(),
};


export default (state = initialState, action) => {
  switch (action.type) {
    // fetch notices
    case `${t.FETCH_NOTIFICATIONS}_PENDING`:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_NOTIFICATIONS}_SUCCESS`:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.notifications.pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_NOTIFICATIONS}_ERROR`:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET:
      return {
        ...state,
        notifications: makeOffesetPaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/notifications/reducer.js